<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon name="stop-hand"></sym-icon></span>
		<div class="fi-row-message">
			<span style="font-weight: bold">{{ env.msg('activity.collectingFeedback') }}:</span>
			<span>
				<template v-for="(blk, idx) in blockingUsers" :key="blk.id">
					<template v-if="idx>0">, </template>
					<object-link :src-id="blk.id" :src-type="SrcType.PARTY">{{ blk.name }}</object-link>
				</template>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {watch, ref} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {injectEnv} from "@fd/Environment.ts";
import {useUserStore} from "@/store/UserStore.ts";
import ItLink from "@/router/ItLink.vue";
import ObjectLink from "@fd/helpers/ObjectLink.vue";
import {SrcType} from "@t/meta/SourceType.ts";

const props = defineProps<{
	blocks:(string|number)[]
}>();
const env = injectEnv();
const us = useUserStore();

interface UName { id: string|number, name: string }
const blockingUsers = ref<UName[]>([]);

function sortInUser(id: string|number, name:string):void {
	const un:UName = {id: id, name: name};
	for (let i = 0; i < blockingUsers.value.length; i++) {
		const a = blockingUsers.value[i];
		if (a.name.localeCompare(name) > 0) {
			blockingUsers.value.splice(i, 0, un);
			return;
		}
	}
	blockingUsers.value.push(un);
}

function fetchNames() {
	blockingUsers.length = 0;
	for (let block of props.blocks) {
		us.findName(block).then((name) => sortInUser(block, name));
	}
}

watch(() => props.blocks, () => {
	fetchNames();
}, { deep: true, immediate: true });
</script>

<style>

</style>